import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

// A persistent, unmissable "Messages" launcher for vetted members.
const InboxFab = () => {
  const { isMember } = useAuth();
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);

  const loadUnread = useCallback(async () => {
    try {
      const r = await fetch(`${API}/api/community/conversations`, { credentials: 'include' });
      if (r.ok) setUnread((await r.json()).unread || 0);
    } catch (_) { /* ignore */ }
  }, []);

  useEffect(() => {
    if (!isMember) return;
    loadUnread();
    const iv = setInterval(loadUnread, 15000);
    return () => clearInterval(iv);
  }, [isMember, loadUnread]);

  if (!isMember) return null;

  return (
    <button
      onClick={() => navigate('/community/inbox')}
      data-testid="inbox-fab"
      aria-label="Open messages"
      className="fixed bottom-6 right-6 z-[150] group inline-flex items-center gap-2.5 pl-4 pr-5 py-3.5 rounded-full bg-slate-900 text-white shadow-[0_12px_40px_-8px_rgba(15,23,42,0.55)] hover:bg-slate-800 hover:-translate-y-0.5 transition-all duration-200"
    >
      <span className="relative inline-flex">
        <MessageSquare className="w-5 h-5" />
        {unread > 0 && (
          <span className="absolute -top-2.5 -right-2.5 min-w-5 h-5 px-1 flex items-center justify-center text-[10px] font-extrabold text-white bg-red-500 rounded-full ring-2 ring-slate-900" data-testid="inbox-fab-unread">
            {unread > 99 ? '99+' : unread}
          </span>
        )}
      </span>
      <span className="text-sm font-bold">Messages</span>
      {unread > 0 && (
        <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" aria-hidden="true" />
      )}
    </button>
  );
};

export default InboxFab;
